import React from "react";
import "./about.css";
import aboutImg from "../../Media/abtimg.png";
import appLogo from "../../Media/zzz.png";

const About = () => {
  return (
    <div className="about" id="about">
      <div className="about_left">
        <img src={aboutImg} alt="about-img" />
      </div>
      <div className="about_right">
        <div>
          <div className="about-title">
            <h1>About</h1>
            <img src={appLogo} alt="logoimg" />
          </div>

          <p>
            DepRelief is an online therapy website that was developed in the
            hopes of connecting people who are going through alot mentally with
            other people just like them.
          </p>
          <p>
            We are here for the people who are secretly fighting mental,
            emotional and physical battles.
          </p>
          <p style={{ color: "#54cba7" }}>
            "We hope you love yourself as much as we love you."
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
